import React, { ReactElement } from "react";
import "./GenericInputField.css";
import { TextField } from "@mui/material";

interface GenericInputFieldProps {
	currentValue: string;
	placeholder: string;
	multiline?: boolean;
	endAdornment?: ReactElement;
	onValueChange: (value) => void;
}

const GenericInputField: React.FunctionComponent<GenericInputFieldProps> = ({
	currentValue,
	placeholder,
	endAdornment,
	multiline = false,
	onValueChange,
}) => {
	return (
		<TextField
			value={currentValue || ""}
			sx={{ backgroundColor: "transparent" }}
			fullWidth
			onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
				onValueChange(e.target.value)
			}
			hiddenLabel
			placeholder={placeholder}
			InputProps={{
				endAdornment: endAdornment,
				classes: {
					root: "input-root",
					focused: "input-focused",
				},
			}}
			multiline={multiline}
			rows={3}
		/>
	);
};

export default GenericInputField;
